import React from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
// import { Link } from 'react-router-dom';
import { signUp } from '../actions/auth';
import  PageHeader  from './PageHeader';
import  NavBarMultiPage   from "../components/common/NavBarMultiPage";
import  VisibilityWrapper from "../components/common/VisibilityWrapper";
import  SignUpForm  from './SignUpForm';
// import  { FooterSection }  from './FooterSection';
import   Footer from "../components/common/Footer";
import  getAppConfigParm  from '../config/AppConfig';
import { displayAd } from './advertisements/helpers/displayAd';
// import { GoogleAdInit } from './advertisements/GoogleAdInit';
// import { runInThisContext } from 'vm';
// import setAuthorizationToken from '../utils/setAuthorizationToken.js';

// This page renders a <SignUpForm>. This page passes the onSubmit function prop (defined below) to the form.
// Once the form has validated the input data and successfully created new user account, the form calls the 
// function prop provided by this component(parent), passing in the data needed to decide to dispatch action,
// and decide with page to route use based on outcome of form submission. The decision is made below
// As a side note, the history module used in onSubmit, is available because this compoment is registered 
// as a Route, so there was no need to import history in this module
export class SignUpPage extends React.Component { 

    onSubmit = (signUpData = {}) => {
        /* if received token (CreateNewUser was successfull); dispatch signup action to save user info in local storage */
        if (signUpData.token) {  
            // setAuthorizationToken(signUpData.token);  /* set x-auth header (with token) as default on axios header */
            this.props.signUp(signUpData);  /* signUpData is an object with user {firstname, email} and token property */
            this.props.history.push('/dashboard');    
        } else {  /* else means we had an error. Keep user on signup page */
            this.props.history.push('/homepage');    
        }
    };

    /* This function adjusts the view port height based on whether Ads are displayed or not. The function
       returns an object with the height property */
    getPageContainerStyle = () => {
        // console.log("showAd is ==>", getAppConfigParm("showAd") )
        return getAppConfigParm("showAd") ? { height: '73vh' } :  { height: '70vh' }
    }

    render() {

        /* Get the showAd directive from the AppConfig */
        let showAd = getAppConfigParm("showAd");

        return (
            <div> 
            {/* <div style={this.getPageContainerStyle()}> */}
               <Helmet>
                   <title>Sign Up for PitchIn Club</title>
                   <meta name="description" content="Sign Up Page for Pitch In Club" />
               </Helmet>
               { /* <PageHeader />  */ }
               <PageHeader pageName="home" />
               <VisibilityWrapper show={showAd} contentType="advertisement">
                <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
                </div>
               </VisibilityWrapper>  
               <div className="app-container-alt2">    
                   <div className="rc-horiz-spacer-large">&nbsp;</div> 
                   <div className="app-content-container"> 
                     <div className="rc-horiz-spacer-medium">
                        <h3 className="form__title">Join the Club</h3>
                        <h4 className="form__subtitle">The easy way to organize and have people "Pitch in"</h4>
                        <SignUpForm 
                            onSubmit={this.onSubmit}
                        />  
                     </div> 
                    </div>
               </div>
               <VisibilityWrapper show={false} contentType="advertisement" >
                <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
                </div> 
               </VisibilityWrapper>
               <Footer />
            </div>
        );
    };
};

// When using mapDispatchToProps you invoke function in your component as 
// this.props.startSignup(signupData) not this.props.dispatch(startSignup(signupData))
const mapDispatchToProps = (dispatch) => ({
    signUp: (token) => dispatch(signUp(token)),
})

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};


// Lets connect to the store, to be able to call dispatch.
export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
// export default connect()(SignUpPage);


// WEBPACK FOOTER //
// ./src/components/SignUpPage.js